import { Box } from '@mui/system';
import {
    FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField,
} from '@mui/material';
import { WidgetOption } from './WidgetSelector';

type ForcedRanking = Models.SetsPlayground.ForcedSetRanking;
type SortingDirection = Models.SetsPlayground.SortingDirection;

interface Props {
    value: ForcedRanking;
    onChange: (next: ForcedRanking) => void;
}

/**
There is temporay hardcoding in this compeont to support single ranking strategy.
Consider refactoring when we support multiple ranking strategies.
 */

const ForcedRankingWidgetComponent = ({ value, onChange }: Props): JSX.Element => {
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        onChange({ ...value, rankingStrategies: [{ ...value.rankingStrategies[0], name: e.target.value }] });
    };

    const handleDirectionChange = (e: SelectChangeEvent<string>): void => {
        onChange({
            ...value,
            rankingStrategies: [{ ...value.rankingStrategies[0], sortingDirection: (e.target.value as SortingDirection) || 'descending' }],
        });
    };

    return (
        <Box display="grid" gap={2} gridTemplateColumns={{ xs: '1fr', sm: '2fr 1fr' }}>
            <TextField
                fullWidth
                label="Strategy name"
                placeholder="e.g. newest, globalranking"
                size="small"
                value={value.rankingStrategies[0].name}
                onChange={handleNameChange}
            />
            <FormControl fullWidth size="small">
                <InputLabel>Sorting direction</InputLabel>
                <Select
                    label="Sorting direction"
                    value={value.rankingStrategies[0].sortingDirection}
                    onChange={handleDirectionChange}
                >
                    <MenuItem value="ascending">Ascending</MenuItem>
                    <MenuItem value="descending">Descending</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};

export const ForcedRankingWidget: WidgetOption<ForcedRanking> = {
    label: 'Forced Ranking',
    value: 'forced',
    helperText: 'Provide a strategy name and sort direction.',
    component: ForcedRankingWidgetComponent,
    getDefaultValue: () => ({
        type: 'forced',
        rankingStrategies: [{ name: '', sortingDirection: 'descending' }],
    }),
};
